import { LogResponse } from "@/api/LogsService"

export enum LogSource {
   INMATE = "inmate",
   CELL = "cell",
}

export enum AlarmState {
   ENABLED = "Enabled",
   DISABLED = "Disabled",
}

export enum OpenCellScheduleEvent {
   CREATED = "created",
   UPDATED = "updated",
   DELETED = "deleted",
   STARTED = "started",
   ENDED = "ended",
}

export interface Log extends LogResponse {
   source?: LogSource
}

export type LogType = "Clearance" | "Change" | "Creation"
